import { render, staticRenderFns } from "./DoctorAssistantRelationModal.vue?vue&type=template&id=c7a4ef86&"
import script from "./DoctorAssistantRelationModal.vue?vue&type=script&lang=js&"
export * from "./DoctorAssistantRelationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports